import UdeskList from 'Component/common/udesk-list';
import React from 'react';
import Udesk from 'Udesk';
import { Button, Checkbox, Icon, PageHeader, Select, Switch, Tooltip } from 'udesk-ui';
import { enableQa } from 'Udesk/business';
import UdeskLocales from 'UdeskLocales';
import { getDataDeleteConfig } from './component';
import { DataDeleteConfigItem } from './components/DataDeleteConfigItem';
import PageLanguageSelect from './components/PageLanguageSelect';
import AdminSystemIndexRoute from './route';
import './style.scss';

export default class AdminSystemIndexTemplate extends AdminSystemIndexRoute {
    render() {
        let { actions, locales, privates } = this;
        const company = Udesk.data.init.company;

        const imSendStatusFilterOptions = [
            { label: locales.pages.admin.system.template.shieldingWithdrawn, value: 1 },
            { label: locales.pages.admin.system.template.maskSendingFailed, value: 2 },
            {
                label: /* 屏蔽离线消息未读 */ locales.pages.admin.system.template
                    .maskOfflineMessageUnread,
                value: 4,
            },
            // {
            //     label: /* 屏蔽系统发送消息 */ UdeskLocales['current'].pages.admin.system.template
            //         .blockSystemSendingMessages,
            //     value: 8,
            // },
        ];

        const ticketSendStatusFilterOptions = [
            {
                label: /* 屏蔽短信 */ UdeskLocales['current'].pages.admin.system.template.blockSMS,
                value: 1,
            },
            {
                label: /* 屏蔽内部备注 */ UdeskLocales['current'].pages.admin.system.template
                    .maskInternalRemarks,
                value: 2,
            },
            {
                label: /* 屏蔽变更记录 */ UdeskLocales['current'].pages.admin.system.template
                    .maskChangeRecord,
                value: 4,
            },
        ];

        const dataDeleteConfig = privates.model.sysConfig.dataDeleteConfig || [];

        const scopeOptions = getDataDeleteConfig().scopeOptions;

        return (
            // <div className="page admin-system-index">
            <div className="udesk-qa-web-page">
                <PageHeader
                    className="udesk-qa-web-page-header"
                    title={locales.pages.admin.system.index.name}
                />

                <div className="udesk-qa-web-page-body">
                    <div
                        className="udesk-qa-web-page-body-root qa-page-admin-systom-index"
                        style={{ padding: 16 }}
                    >
                        <div className="page-content">
                            <div className="x_panel clearfix">
                                <div className="x_content clearfix">
                                    <div className="col-lg-9 col-md-9 col-xs-12 col-12">
                                        <If
                                            condition={
                                                Udesk.data.init.user &&
                                                Udesk.data.init.user.hasFeature('sys:info:view')
                                            }
                                        >
                                            <form className="form-horizontal form-label-left">
                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                        htmlFor="system-name"
                                                    >
                                                        {
                                                            locales.pages.admin.system.index
                                                                .systemName
                                                        }
                                                    </label>
                                                    <div className="col-lg-7 col-md-7 col-xs-12 col-12">
                                                        <input
                                                            type="text"
                                                            id="system-name"
                                                            className="form-control"
                                                            value={privates.model.sysConfig.sysName}
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onValueChanged.params(
                                                                privates.model.sysConfig,
                                                                'sysName'
                                                            )}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {locales.pages.admin.system.index.massage}
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{ height: 30, lineHeight: '30px' }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .enabledMessage
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onSwitchValueChanged.params(
                                                                privates.model.sysConfig,
                                                                'enabledMessage'
                                                            )}
                                                        ></Switch>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {locales.pages.admin.system.index.evaluate}
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap',
                                                                    }}
                                                                >
                                                                    {
                                                                        locales.pages.admin.system
                                                                            .index.evaluateTip
                                                                    }
                                                                </div>
                                                            }
                                                        >
                                                            <Icon
                                                                type="QuestionCircleOutlined"
                                                                antdIcon={true}
                                                            ></Icon>
                                                        </Tooltip>
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{ height: 30, lineHeight: '30px' }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .enabledEvaluate
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onSwitchValueChanged.params(
                                                                privates.model.sysConfig,
                                                                'enabledEvaluate'
                                                            )}
                                                        ></Switch>
                                                    </div>
                                                </div>

                                                {Udesk.data.init.user &&
                                                    Udesk.data.init.user.hasFeature(
                                                        'sys:info:im:inspect:filter'
                                                    ) && (
                                                        <div className="form-group">
                                                            <label
                                                                className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                                style={{ padding: '0 15px' }}
                                                            >
                                                                {
                                                                    locales.pages.admin.system.index
                                                                        .enabledImSendStatusFilter
                                                                }
                                                                <Tooltip
                                                                    title={
                                                                        <div
                                                                            style={{
                                                                                whiteSpace:
                                                                                    'pre-wrap',
                                                                            }}
                                                                        >
                                                                            {
                                                                                locales.pages.admin
                                                                                    .system.index
                                                                                    .enabledImSendStatusFilterTips
                                                                            }
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Icon
                                                                        type="QuestionCircleOutlined"
                                                                        antdIcon={true}
                                                                    ></Icon>
                                                                </Tooltip>
                                                            </label>
                                                            <div
                                                                className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                                style={{
                                                                    // height: 30,
                                                                    lineHeight: '30px',
                                                                }}
                                                            >
                                                                <Checkbox.Group
                                                                    value={(
                                                                        privates.model.sysConfig
                                                                            .enabledImSendStatusFilter ||
                                                                        0
                                                                    )
                                                                        .toString(2)
                                                                        .split('')
                                                                        .reverse()
                                                                        .map(
                                                                            (n, i) =>
                                                                                n * Math.pow(2, i)
                                                                        )
                                                                        .filter(Boolean)}
                                                                    options={
                                                                        imSendStatusFilterOptions
                                                                    }
                                                                    onChange={actions.imSendStatusFilterChange.params(
                                                                        privates.model.sysConfig,
                                                                        'enabledImSendStatusFilter'
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                {Udesk.data.init.user &&
                                                Udesk.data.init.user.hasFeature(
                                                    'sys:info:ticket:inspect:filter'
                                                ) ? (
                                                    <div className="form-group">
                                                        <label
                                                            className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                            style={{ padding: '0 15px' }}
                                                        >
                                                            {/* 工单质检消息过滤 */}
                                                            {
                                                                UdeskLocales['current'].pages.admin
                                                                    .system.template
                                                                    .workOrderQualityInspectionMessageFiltering
                                                            }
                                                            <Tooltip
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {/* 屏蔽后的数据仅展示但不参与智能质检 */}
                                                                        {
                                                                            UdeskLocales['current']
                                                                                .pages.admin.system
                                                                                .template
                                                                                .theMaskedDataIsOnlyDisplayedButDoesNotParticipateInIntelligentQualityInspection
                                                                        }
                                                                    </div>
                                                                }
                                                            >
                                                                <Icon
                                                                    type="QuestionCircleOutlined"
                                                                    antdIcon={true}
                                                                ></Icon>
                                                            </Tooltip>
                                                        </label>
                                                        <div
                                                            className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                            style={{
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            <Checkbox.Group
                                                                value={(
                                                                    privates.model.sysConfig
                                                                        .enabledTicketReplyFilter ||
                                                                    0
                                                                )
                                                                    .toString(2)
                                                                    .split('')
                                                                    .reverse()
                                                                    .map(
                                                                        (n, i) => n * Math.pow(2, i)
                                                                    )
                                                                    .filter(Boolean)}
                                                                options={
                                                                    ticketSendStatusFilterOptions
                                                                }
                                                                onChange={actions.imSendStatusFilterChange.params(
                                                                    privates.model.sysConfig,
                                                                    'enabledTicketReplyFilter'
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}

                                                {enableQa(
                                                    <div className="form-group">
                                                        <label
                                                            className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                            style={{ padding: '0 15px' }}
                                                        >
                                                            {
                                                                /* 质检规则审批 */ locales.pages
                                                                    .admin.system.template
                                                                    .qualityInspectionRuleApproval
                                                            }
                                                            <Tooltip
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {
                                                                            /* 开启后，质检规则修改需要被审批通过后才能生效 */ locales
                                                                                .pages.admin.system
                                                                                .template
                                                                                .afterOpeningTheModificationOfQualityInspectionRulesCanTakeEffectOnlyAfterBeingApproved
                                                                        }
                                                                    </div>
                                                                }
                                                            >
                                                                <Icon
                                                                    type="QuestionCircleOutlined"
                                                                    antdIcon={true}
                                                                ></Icon>
                                                            </Tooltip>
                                                        </label>
                                                        <div
                                                            className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                            style={{
                                                                height: 30,
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            <Switch
                                                                checked={
                                                                    privates.model.sysConfig
                                                                        .enabledInspectRuleApprove
                                                                }
                                                                disabled={
                                                                    !Udesk.data.init.user ||
                                                                    !Udesk.data.init.user.hasFeature(
                                                                        'sys:info:edit'
                                                                    )
                                                                }
                                                                onChange={actions.onSwitchValueChanged.params(
                                                                    privates.model.sysConfig,
                                                                    'enabledInspectRuleApprove'
                                                                )}
                                                            ></Switch>
                                                        </div>
                                                    </div>
                                                )}

                                                {Boolean(company.enabledCallInspect) && (
                                                    <div className="form-group">
                                                        <label
                                                            className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                            style={{ padding: '0 15px' }}
                                                        >
                                                            {
                                                                locales.pages.admin.system.template
                                                                    .privacyNumberProtection
                                                            }
                                                            <Tooltip
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {
                                                                            locales.pages.admin
                                                                                .system.template
                                                                                .afterOpeningDesensitizeThecustomerPhoneFieldInTheCallWhichIsDisplayedAs1881
                                                                        }
                                                                    </div>
                                                                }
                                                            >
                                                                <Icon
                                                                    type="QuestionCircleOutlined"
                                                                    antdIcon={true}
                                                                ></Icon>
                                                            </Tooltip>
                                                        </label>
                                                        <div
                                                            className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                            style={{
                                                                height: 30,
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            <Switch
                                                                checked={
                                                                    privates.model.sysConfig
                                                                        .enabledPhoneNumberProtect
                                                                }
                                                                disabled={
                                                                    !Udesk.data.init.user ||
                                                                    !Udesk.data.init.user.hasFeature(
                                                                        'sys:info:edit'
                                                                    )
                                                                }
                                                                onChange={actions.onSwitchValueChanged.params(
                                                                    privates.model.sysConfig,
                                                                    'enabledPhoneNumberProtect'
                                                                )}
                                                            ></Switch>
                                                        </div>
                                                    </div>
                                                )}
                                                {Boolean(company.enabledImInspect) && (
                                                    <div className="form-group">
                                                        <label
                                                            className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                            style={{ padding: '0 15px' }}
                                                        >
                                                            {/* 文本数据脱敏 */}
                                                            {
                                                                UdeskLocales['current'].pages.admin
                                                                    .system.template
                                                                    .textDataDesensitization
                                                            }
                                                            <Tooltip
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {
                                                                            /* 开关开启则展示脱敏字段下拉列表（支持多选），脱敏字段：人名、手机号、地址 */ UdeskLocales[
                                                                                'current'
                                                                            ].pages.admin.system
                                                                                .template
                                                                                .whenTheSwitchIsTurnedOnTheDesensitizationFieldDropdownListWillBeDisplayedmultipleChoicesAreSupportedTheDesensitizationFieldsPersonNameMobileNumberAddress
                                                                        }
                                                                    </div>
                                                                }
                                                            >
                                                                <Icon
                                                                    type="QuestionCircleOutlined"
                                                                    antdIcon={true}
                                                                ></Icon>
                                                            </Tooltip>
                                                        </label>
                                                        <div
                                                            className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                            style={{
                                                                height: 30,
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            <Switch
                                                                checked={
                                                                    privates.model.sysConfig
                                                                        .enabledDataMask
                                                                }
                                                                disabled={
                                                                    !Udesk.data.init.user ||
                                                                    !Udesk.data.init.user.hasFeature(
                                                                        'sys:info:edit'
                                                                    )
                                                                }
                                                                onChange={actions.onSwitchValueChanged.params(
                                                                    privates.model.sysConfig,
                                                                    'enabledDataMask'
                                                                )}
                                                            ></Switch>
                                                        </div>
                                                    </div>
                                                )}
                                                {Boolean(
                                                    privates.model.sysConfig.enabledDataMask
                                                ) && (
                                                    <div className="form-group">
                                                        <label
                                                            className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                            style={{ padding: '0 15px' }}
                                                        >
                                                            {/* 脱敏字段 */}
                                                            {
                                                                UdeskLocales['current'].pages.admin
                                                                    .system.template
                                                                    .desensitizingField
                                                            }
                                                        </label>
                                                        <div
                                                            className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                            style={{
                                                                height: 30,
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            <Select
                                                                defaultValue={
                                                                    privates.model.sysConfig
                                                                        .dataMaskFields
                                                                }
                                                                mode="multiple"
                                                                disabled={
                                                                    !Udesk.data.init.user ||
                                                                    !Udesk.data.init.user.hasFeature(
                                                                        'sys:info:edit'
                                                                    )
                                                                }
                                                                options={[
                                                                    {
                                                                        value: 'sys_name',
                                                                        label: /* 人名 */ UdeskLocales[
                                                                            'current'
                                                                        ].pages.admin.system
                                                                            .template.name,
                                                                    },
                                                                    {
                                                                        value: 'sys_phone',
                                                                        label: /* 手机号 */ UdeskLocales[
                                                                            'current'
                                                                        ].pages.admin.system
                                                                            .template
                                                                            .cellphoneNumber,
                                                                    },
                                                                    {
                                                                        value: 'sys_address_privacy',
                                                                        label: /* 地址 */ UdeskLocales[
                                                                            'current'
                                                                        ].pages.admin.system
                                                                            .template.address,
                                                                    },
                                                                ]}
                                                                onChange={actions.onSelectValueChanged.params(
                                                                    privates.model.sysConfig,
                                                                    'dataMaskFields'
                                                                )}
                                                                style={{
                                                                    width: 'auto',
                                                                    minWidth: 250,
                                                                }}
                                                            ></Select>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {locales.pages.admin.system.index.lang}
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{ height: 30, lineHeight: '30px' }}
                                                    >
                                                        <PageLanguageSelect
                                                            defaultValue={
                                                                Udesk.data.init.userLanguage
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onUserLanguageChange}
                                                            style={{
                                                                width: 200,
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {enableQa(
                                                    <React.Fragment>
                                                        <div className="form-group">
                                                            <label
                                                                className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                                style={{ padding: '0 15px' }}
                                                            >
                                                                {/* 数据清理 */}
                                                                {
                                                                    UdeskLocales['current'].pages
                                                                        .admin.system.template
                                                                        .dataCleaning
                                                                }
                                                                <Tooltip
                                                                    title={
                                                                        <div
                                                                            style={{
                                                                                whiteSpace:
                                                                                    'pre-wrap',
                                                                            }}
                                                                        >
                                                                            {
                                                                                /* 设置后，质检通对话、企业微信会话数据将定期被清理，且不可恢复，请谨慎操作 */ UdeskLocales[
                                                                                    'current'
                                                                                ].pages.admin.system
                                                                                    .template
                                                                                    .afterSettingTheConversationDataOfQCAndWeChatWillBeCleanedRegularlyAndCannotBeRecoveredPleaseBeCareful
                                                                            }
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Icon
                                                                        type="QuestionCircleOutlined"
                                                                        antdIcon={true}
                                                                    ></Icon>
                                                                </Tooltip>
                                                            </label>
                                                            <div
                                                                className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                                style={{
                                                                    height: 30,
                                                                    lineHeight: '30px',
                                                                }}
                                                            >
                                                                <Switch
                                                                    checked={
                                                                        privates.model.sysConfig
                                                                            .enabledDataDelete
                                                                    }
                                                                    disabled={
                                                                        !Udesk.data.init.user ||
                                                                        !Udesk.data.init.user.hasFeature(
                                                                            'sys:info:edit'
                                                                        )
                                                                    }
                                                                    onChange={actions.onSwitchValueChangedWithEffect.params(
                                                                        actions.onSwitchValueChanged,
                                                                        actions.addDataDeleteConfig.params(
                                                                            true
                                                                        ),
                                                                        privates.model.sysConfig,
                                                                        'enabledDataDelete'
                                                                    )}
                                                                ></Switch>
                                                            </div>
                                                        </div>
                                                        {!!privates.model.sysConfig
                                                            .enabledDataDelete && (
                                                            <div className="form-group">
                                                                <label
                                                                    className="col-lg-3 col-md-4 col-xs-12 col-12"
                                                                    style={{ padding: '0 15px' }}
                                                                ></label>
                                                                <div
                                                                    className="col-lg-9 col-md-8 col-xs-12 col-12"
                                                                    style={{ lineHeight: '30px' }}
                                                                >
                                                                    <UdeskList
                                                                        deleteItem={
                                                                            actions.deleteDataDeleteConfig
                                                                        }
                                                                        addItem={
                                                                            actions.addDataDeleteConfig
                                                                        }
                                                                        addBtnText={
                                                                            /* 新增清理规则 */ UdeskLocales[
                                                                                'current'
                                                                            ].pages.admin.system
                                                                                .template
                                                                                .newCleaningRules
                                                                        }
                                                                        addBtnDisabled={
                                                                            dataDeleteConfig.length >=
                                                                            scopeOptions.length
                                                                        }
                                                                    >
                                                                        {dataDeleteConfig.map(
                                                                            (item, index) => {
                                                                                return (
                                                                                    <DataDeleteConfigItem
                                                                                        {...item}
                                                                                        onChange={actions.onDataDeleteConfigChange.params(
                                                                                            index
                                                                                        )}
                                                                                        usedScopes={dataDeleteConfig.map(
                                                                                            (i) =>
                                                                                                i.scope
                                                                                        )}
                                                                                    />
                                                                                );
                                                                            }
                                                                        )}
                                                                    </UdeskList>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                )}
                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {/* 客服强制下线 */}
                                                        {
                                                            UdeskLocales['current'].pages.admin
                                                                .system.template
                                                                .forcedCustomerServiceOffline
                                                        }
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap',
                                                                    }}
                                                                >
                                                                    {/* 开启后，当客户未按时间要求完成质培任务时，会强制客服下线 */}
                                                                    {
                                                                        UdeskLocales['current']
                                                                            .pages.admin.system
                                                                            .template
                                                                            .afterOpeningWhenTheCustomerFailsToCompleteTheQualityTrainingTaskAccordingToTheTimeRequirementTheCustomerServiceWillBeForcedToGoOffline
                                                                    }
                                                                </div>
                                                            }
                                                        >
                                                            <Icon
                                                                type="QuestionCircleOutlined"
                                                                antdIcon={true}
                                                            ></Icon>
                                                        </Tooltip>
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{
                                                            height: 30,
                                                            lineHeight: '30px',
                                                        }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .enabledAgentOnlineStatus
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onForcedOffline}
                                                        ></Switch>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {/* 大模型标签省流模式 */}
                                                        {
                                                            UdeskLocales['current'].pages.admin
                                                                .system.template
                                                                .largeModelLabelSaveFlowMode
                                                        }
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap',
                                                                    }}
                                                                >
                                                                    {/* 开启后，只针对与会话内容相关的智能标签进行大模型打标 */}
                                                                    {
                                                                        UdeskLocales['current']
                                                                            .pages.admin.system
                                                                            .template
                                                                            .whenEnabledLargeModelMarkingIsPerformedOnlyForSmartTagsRelatedToSessionContent
                                                                    }
                                                                </div>
                                                            }
                                                        >
                                                            <Icon
                                                                type="QuestionCircleOutlined"
                                                                antdIcon={true}
                                                            ></Icon>
                                                        </Tooltip>
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{
                                                            height: 30,
                                                            lineHeight: '30px',
                                                        }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .labelSaveMode
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onTagEconomizingMode}
                                                        ></Switch>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {/* 大模型质检省流模式 */}
                                                        {
                                                            UdeskLocales['current'].pages.admin
                                                                .system.template
                                                                .largeModelQualityInspectionProvincialFlowMode
                                                        }
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap',
                                                                    }}
                                                                >
                                                                    {/* 开启后，只针对与会话内容相关的智能模型规则进行大模型质检 */}
                                                                    {
                                                                        UdeskLocales['current']
                                                                            .pages.admin.system
                                                                            .template
                                                                            .afterEnabledLargeModelQualityInspectionIsPerformedOnlyForIntelligentModelRulesRelatedToSessionContent
                                                                    }
                                                                </div>
                                                            }
                                                        >
                                                            <Icon
                                                                type="QuestionCircleOutlined"
                                                                antdIcon={true}
                                                            ></Icon>
                                                        </Tooltip>
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{
                                                            height: 30,
                                                            lineHeight: '30px',
                                                        }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .ruleSaveMode
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={actions.onQaEconomizingMode}
                                                        ></Switch>
                                                    </div>
                                                </div>

                                                {Udesk.data.init.user &&
                                                Udesk.data.init.user.hasFeature(
                                                    'sys:largeAi:qa:pic'
                                                ) ? (
                                                    <div className="form-group">
                                                        <label
                                                            className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                            style={{ padding: '0 15px' }}
                                                        >
                                                            {/* 多模态质检 */}
                                                            {
                                                                UdeskLocales['current'].pages.admin
                                                                    .system.template
                                                                    .multimodalQualityInspection
                                                            }
                                                            <Tooltip
                                                                title={
                                                                    <div
                                                                        style={{
                                                                            whiteSpace: 'pre-wrap',
                                                                        }}
                                                                    >
                                                                        {/* 使用多模态大模型，对会话中的图片、音视频进行质检 */}
                                                                        {
                                                                            UdeskLocales['current']
                                                                                .pages.admin.system
                                                                                .template
                                                                                .useALargeMultimodalModelToCheckThePicturesAudioAndVideoInTheSession
                                                                        }
                                                                    </div>
                                                                }
                                                            >
                                                                <Icon
                                                                    type="QuestionCircleOutlined"
                                                                    antdIcon={true}
                                                                ></Icon>
                                                            </Tooltip>
                                                        </label>
                                                        <div
                                                            className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                            style={{
                                                                height: 30,
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            <Checkbox
                                                                disabled={
                                                                    !Udesk.data.init.user ||
                                                                    !Udesk.data.init.user.hasFeature(
                                                                        'sys:info:edit'
                                                                    )
                                                                }
                                                                checked={
                                                                    privates.model.sysConfig
                                                                        .enabledPictureOcrAi === 1
                                                                }
                                                                onChange={(e) =>
                                                                    actions.onPictureOcrAiChange(
                                                                        e.target.checked ? 1 : 0
                                                                    )
                                                                }
                                                            >
                                                                {/* 图片识别 */}
                                                                {
                                                                    UdeskLocales['current'].pages
                                                                        .admin.system.template
                                                                        .pictureRecognition
                                                                }
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                ) : null}

                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {/* 过滤非人工 */}
                                                        {
                                                            UdeskLocales['current'].pages
                                                                .speechRecognition.template
                                                                .nonmanualFiltering
                                                        }
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{
                                                                        whiteSpace: 'pre-wrap',
                                                                    }}
                                                                >
                                                                    {/* 启用后，仅转写人工通话 */}
                                                                    {
                                                                        UdeskLocales['current']
                                                                            .pages.speechRecognition
                                                                            .template
                                                                            .whenEnabledOnlyTranscribeManualCalls
                                                                    }
                                                                </div>
                                                            }
                                                        >
                                                            <Icon
                                                                type="QuestionCircleOutlined"
                                                                antdIcon={true}
                                                            ></Icon>
                                                        </Tooltip>
                                                    </label>
                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{
                                                            height: 30,
                                                            lineHeight: '30px',
                                                        }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .enabledNonHumanFilter === 1
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={
                                                                actions.onEnabledNonHumanFilterChange
                                                            }
                                                        ></Switch>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label
                                                        className="control-label control-label-right col-lg-3 col-md-4 col-xs-12 col-12"
                                                        style={{ padding: '0 15px' }}
                                                    >
                                                        {/* 单封邮件质检 */}
                                                        {
                                                            UdeskLocales['current'].pages.admin
                                                                .system.template
                                                                .singleMailQualityInspection
                                                        }
                                                    </label>

                                                    <div
                                                        className="col-lg-7 col-md-7 col-xs-12 col-12"
                                                        style={{
                                                            height: 30,
                                                            lineHeight: '30px',
                                                        }}
                                                    >
                                                        <Switch
                                                            checked={
                                                                privates.model.sysConfig
                                                                    .receiveAllTickets === 1
                                                            }
                                                            disabled={
                                                                !Udesk.data.init.user ||
                                                                !Udesk.data.init.user.hasFeature(
                                                                    'sys:info:edit'
                                                                )
                                                            }
                                                            onChange={
                                                                actions.onEnabledSingleEmailQa
                                                            }
                                                        ></Switch>
                                                    </div>
                                                </div>

                                                <If
                                                    condition={
                                                        Udesk.data.init.user &&
                                                        Udesk.data.init.user.hasFeature(
                                                            'sys:info:edit'
                                                        )
                                                    }
                                                >
                                                    <div className="form-group">
                                                        <div className="col-lg-10 col-md-10 col-xs-12 col-12 col-md-offset-2">
                                                            <Button
                                                                type="primary"
                                                                onClick={actions.save}
                                                            >
                                                                {locales.labels.save}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </If>
                                            </form>
                                        </If>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
